import { Spinner } from '@Components/common/Spinner';
import { ReactNode } from 'react';
import { Button, ContentWrapper, Div, FormError, Title, Wrapper } from './FormWrapper.styled';
type Props = {
  title?: string;
  cta?: string;
  children: ReactNode;
  error?: String;
  loading?: boolean;
  formId?: string;
};

export default function FormWrapper({ title, cta, children, error, loading, formId }: Props) {
  // const [isLoading, setIsLoading] = useState<boolean>(loading);
  return (
    <ContentWrapper>
      <Wrapper>
        <Title>{title}</Title>
        <Div>{children}</Div>
      </Wrapper>
      <Button variant="filled-red" type="submit" disabled={loading} form={formId}>
        {loading ? <Spinner /> : cta}
      </Button>
      <FormError>{error}</FormError>
    </ContentWrapper>
  );
}
